// Import the configured consumer from our cable.js
import consumer from '../cable'

export default consumer
